// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3ecpm","errorLogs":"styles_errorLogs__wluzq"};